import { createSelector } from 'reselect';
import { getCheckout } from '../selectors.js';
import { isUninitialized } from '../state.js';

const getPayment = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.payment ? checkout.payment : undefined
);
const getSelectedPaymentMethod = createSelector(getPayment, (payment)=>payment && payment.selectedPaymentMethod ? payment.selectedPaymentMethod : undefined
);
const getPaymentDetails = createSelector(getPayment, (payment)=>payment && payment.paymentDetails ? payment.paymentDetails : undefined
);
createSelector(getPaymentDetails, getSelectedPaymentMethod, (paymentDetails, paymentMethod)=>{
    if (!paymentMethod || !paymentDetails) {
        return undefined;
    }
    const { provider  } = paymentMethod;
    if (!provider) {
        return undefined;
    }
    const paymentMethods = paymentDetails[provider];
    if (!paymentMethods) {
        return undefined;
    }
    return paymentMethods;
});
createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.payment.paymentFlow ? checkout.payment.paymentFlow : undefined
);

export { getPayment, getPaymentDetails, getSelectedPaymentMethod };
//# sourceMappingURL=selectors.js.map
